module.exports = __webpack_public_path__ + "img/softwareLogo1.5111a6f9.png";